import React from 'react';
import { browserHistory } from 'react-router';

const Table = props => {
	const {intl, tableData, initPopup} = props;

	return (
		<table className="dashboard-table accounts-table">
			<thead className="dashboard-table__head font-proxima-nova-semibold">
				<tr>
					<td className="account">{intl('Аккаунт')}</td>
					<td className="price">{intl('Стоимость')}</td>
					<td className="available">{intl('Доступно')}</td>
				</tr>
			</thead>
			<tbody className="dashboard-table__body font-proxima-nova-semibold">

				{tableData.map((item) => {
					return item.isCategoryRow
						? CategoryRow(item.category_name)
						: AccountRow({...item, initPopup, intl});
				})}
			</tbody>
		</table>
	);
};

const CategoryRow = name =>
	<tr className="category__row">
		<td colSpan="3">{name}</td>
	</tr>;

const AccountRow = params => {
	const {
		name, description, price, currency, available_amount, initPopup, image,
		id, intl
	} = params;

	return <tr
		className="account__row"
		onClick={() => { browserHistory.push(`bm-accounts/${id}`);}}
	>
		<td className="account">
			<div
				className="account-description"
				style={image ? {backgroundImage: `url('${image}')`} : {}}
			>
				{name} {description}
			</div>
		</td>
		<td className="price">
			<div className="account__price"><span>{currency} {Math.round(price)}/{intl('аккаунт')}</span></div>
		</td>
		<td className="available">
			<div className="available__amount">
				<span>{available_amount}</span>
				<button
					className="button yellow-btn font-proxima-nova-semibold"
					onClick={(e) => {e.stopPropagation(); initPopup(id);}}
				>
					{intl('Купить')}
				</button>
			</div>
		</td>
	</tr>;
};
export default Table;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/bm-accounts/components/table.js